import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { DPO_CONSTANT } from './../utils/constant';
import { BehaviorSubject } from 'rxjs';

// Consultation Srevice to handle the API calls related to consultation screen only
@Injectable()
export class ConsultationService {

    private data: BehaviorSubject<Object>;

    constructor(private httpService: HttpService) { }

    // Method to call a API for search
    public search(params: any) {
        const queryParams = this.httpService.prepareQueryParams(params);
        const finalUrl = DPO_CONSTANT.CONSULTATION_SEARCH + queryParams;
        return this.httpService.get(finalUrl);
    }

    // Method to call a API for getting all subscription status
    //CAP-20457: LOT1.1: START - LOAD LANGUAGES FOR Subscription Status from JSON
    public getSubscriptionOptions() {
        const finalUrl = DPO_CONSTANT.CONSULTATION_SUBSCRIBED_STATUS;
        return this.httpService.get(finalUrl);
    }
    //CAP-20457: LOT1.1: STOP - LOAD LANGUAGES FOR Subscription Status from JSON

    // Method to call a API for getting the operation details
    public details(params: any) {
        const queryParams = this.httpService.prepareQueryParams(params);
        const finalUrl = DPO_CONSTANT.CONSULTATION_DETAILS + queryParams;
        return this.httpService.get(finalUrl);
    }

    // Method to call a API for getting all the available RRDIs
    public getRrdiAutoCompleteList() {
        const finalUrl = DPO_CONSTANT.CONSULTATION_RRDI_AUTOCOMPLETE;
        return this.httpService.get(finalUrl);
    }
}